import CardComponent from "./CardComponent";

export class ReviewsAndDistance extends CardComponent {
    getOptions = (createHtmlData = {}) => {
        super.getOptions(createHtmlData);
        this.options.locale_is_gb = window.Bark.LOCALE.iso2c === 'gb';
        return this.options;
    }
}
